import http from "../utils/http";

export default {

  async getCoaches(params) {
    return http({
      url: `api/coach-profile/public-profiles`,
      method: "get",
      params
    });
  },
  async getCoach(id, params) {
    return http({
      url: `api/coach-profile/${id}`,
      method: "get",
      params
    });
  }
  ,
  async getExclusiveCoach(slug, params) {
    return http({
      url: `api/coach-profile/exclusive-coach-profile/${slug}`,
      method: "get",
      params
    });
  }
};
